<div #tieredMenu>
	<p-tieredMenu #menu [model]="list" [popup]="true" [styleClass]="'customDropDown'" [ngClass]="{'menu': true}"
		appendTo="body">
	</p-tieredMenu>
	<button *ngIf="!disabled" #btn type="button" class="dropdrop-btn {{cssClassIcon}}" pButton
		[icon]="'fa fa-' + (option?.icon || 'cog')" label="" (click)="$event.preventDefault(); $event.stopPropagation();menu.toggle($event)"></button>
	<p class="mb-auto" *ngIf="disabled && option?.showNAIfIsEmpty">
		{{'g.n/a' | translate}}
	</p>
</div>